

import React from "react";
import { LatLngExpression, Map } from "leaflet";
import { MapContainer, TileLayer } from 'react-leaflet'

const CONTRIBUTORS: string = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
const URL: string = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';


export function translate_openmap_gps(gps: google.maps.LatLngLiteral): LatLngExpression {
    return [gps.lat, gps.lng]
}

function OpenMapUi({
    center,
    zoom,
    children,
    setMap
}: {
    center: LatLngExpression;
    zoom: number;
    children: JSX.Element | React.ReactNode[];
    setMap: (map: Map) => void
}) {

    return (
        <MapContainer style={{ width: '100%', height: '100%', position: "relative" }}
            center={center} zoom={zoom}
            scrollWheelZoom={true} zoomControl={false} ref={setMap} >
            <TileLayer
                attribution={CONTRIBUTORS}
                url={URL}
            />

            {
                React.Children.map(children, (child) => {
                    if (React.isValidElement(child)) {
                        // @ts-ignore
                        return React.cloneElement(child);
                    }
                })
            }

        </MapContainer>
    )
}



export default OpenMapUi